import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-donate',
    templateUrl: './donate.component.html',
    standalone: false
})
export class DonateComponent implements OnInit {

  /**
   * prefix for all texts
   */
  @Input() textkeyPrefix: string;

  /**
   * toggle for the donation form
   */
  showDonationForm: boolean = false;

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    // add embed script from twingle (only once per page):
    // the generic embed declares a global `const containerId`, so loading it
    // twice throws "Identifier 'containerId' has already been declared".
    const src = '//spenden.twingle.de/embed/generic';
    if (document.querySelector(`script[src="${src}"]`)) {
      return;
    }
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = src;
    document.body.appendChild(s);
  }

}
